import {HTTP_METHODS} from '../httpMethods'

export const PRODUCTS_CONFIG = {
  PRODUCT_LIST: queryParams => ({
    endPoint: 'product?' + queryParams,
    // mockData: ProductListData,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.POST,
  }),

  PRODUCT_CSV_DOWNLOAD: queryParams => ({
    endPoint: 'product/download?' + queryParams,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),

  PRODUCT_ENRICHMENT_TEMPLATE_DOWNLOAD: queryParams => ({
    endPoint: 'product/enrichment/download?' + queryParams,
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      'scope': 'pepsi',
    },
  }),

  UPDATE_PRODUCT: {
    endPoint: 'product',
    method: HTTP_METHODS.PUT,
    baseUrlKey: 'inventoryApiUrl',
  },

  UPLOAD_PRODUCT_MEDIA: productId => ({
    endPoint: `product/${productId}/image/upload`,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      'scope': 'pepsi',
    },
  }),
}
